import type {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { useAuthStore } from "@/application/stores/authStore";
import { useAppStore } from "@/application/stores/app";
import { useClubStore } from "@/application/stores/clubStore";
import { env } from "@/application/config/env";
import keycloak from "@/application/plugins/keycloak";
import router from "@/router";

export const onRequestFulFilled = async (
  request: InternalAxiosRequestConfig,
) => {
  request.baseURL = env.root_api;
  request.headers["x-platform"] = "WEB";
  request.headers["x-version"] = "1";

  if (keycloak.authenticated) {
    await keycloak.updateToken(30).catch(() => keycloak.login());
    request.headers.Authorization = `Bearer ${keycloak.token}`;
  }

  if (keycloak.authenticated && !request.url?.startsWith("/v1/clubs/me")) {
    const clubStore = useClubStore();
    await clubStore.ensureLoaded().catch(() => undefined);
    if (clubStore.activeClubId) {
      request.headers["x-club-id"] = clubStore.activeClubId;
    }
  }

  return request;
};

export const onRequestRejected = (error: AxiosError) => error;
export const onResponseFulFilled = (response: AxiosResponse) => response;

export const onResponseRejected = (error: AxiosError) => {
  const authStore = useAuthStore();
  const appStore = useAppStore();

  const { response } = error;

  if (!response) return Promise.reject(error);

  const { status } = response;

  if (status === 401) {
    appStore.setRedirectUrl();
    authStore.login();
  }

  if ([403, 404, 500].includes(status)) {
    router.replace({ name: "error", params: { errorCode: status } });
  }

  return Promise.reject(error);
};
